import { Fragment, FC, useEffect, memo, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { DashboardLayout } from 'Components';
import { WarnAndTips } from './WarnsAndTips';
import { SpecialOpportunity } from './SpecialOpportunity';
import { NewsAndCampaigns } from './NewsAndCampaigns';
import { useDispatch, useSelector } from 'react-redux';
import { onGetCardListRequest } from 'Stores/CardTransactions';
import { UserState, userStore } from 'Stores/User';
import { MasterpassServicess, MasterPassTokenEnum } from 'Utils';
import { onGetCreditCardListFail, onGetMasterpassTokenRequest } from 'Stores/CreditCardTransactions';
import { checkMasterPassAccountNormalize } from 'Normalize';
import {
  AccountState,
  getCampaignsRequest,
  getCityListRequest,
  getNewsRequest,
  onGetCustomerInfoRequest,
  onGetLoginLogListRequest,
  storeAccount,
  setSecurityImageDialogOpen,
} from 'Stores/Account';
import { useLocalization } from 'Hooks';
import { localStorageKeys } from 'Config';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@material-ui/core';
import moment from 'moment';
import { colors, fontSizes } from 'Theme/Variables';

import './Home.scss';
import { AppState, onInıtDataStore, setUpdateAgreementRequired, setRILoginWithOpenIdForce, storeApp } from 'Stores/App';
import { applicationStore } from 'Stores/CardApplication';
import UpdateAgreements from 'Views/UpdateAgreements/UpdateAgreements';
import { routePath } from 'Navigator/routes';

export type AgreementListProps = {
  AgreementType: number;
  AgreementVersion: number;
  Required: boolean;
  ReadOnly: boolean;
};

type HomeParams = {};
type HomeProps = RouteComponentProps<HomeParams>;

const Home: FC<HomeProps> = memo(() => {
  const { web_warning_visible_all } = useLocalization();
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoginLogDialogOpen, setIsLoginLogDialogOpen] = useState(false);
  const [isDialogDismissed, setIsDialogDismissed] = useState(() => {
    return sessionStorage.getItem('loginLogDialogDismissed') === 'true';
  });

  const userData: UserState = useSelector(userStore);
  const onInıtData = useSelector(onInıtDataStore);
  const appState: AppState = useSelector(storeApp);
  const accountState: AccountState = useSelector(storeAccount);

  const customerNumber = userData?.customerNumber;
  const sessionToken = userData?.sessionToken;
  const userCampaigns = accountState?.campaigns;
  const userNews = accountState?.news;
  const updateRequired = appState.agreementUpdateRequired;
  const loginLogList = accountState?.loginLogList;
  const customerInfo = accountState?.customerInfo;

    // Get last 2 login logs (newest first)
  const lastTwoLogins = loginLogList ? loginLogList.slice(0, 2) : [];
  
  // Show dialog if unsuccessful login detected
  const shouldShowUnsuccessLoginDialog = customerInfo?.data?.UnsuccessLogin;
  
  // Check if security image needs to be set
  const securityImageId = customerInfo?.data?.SecurityImageId;


  const language = localStorage.getItem(localStorageKeys.i18nextLng);
  const languageId = language === 'en' ? '1' : '2';

  const checkAgreementStatus = () => {
    // RILoginWithOpenIdForce zaten işlendiyse tekrar kontrol etme
    const riLoginForceHandled = sessionStorage.getItem('riLoginWithOpenIdForceHandled') === 'true';
    if (riLoginForceHandled) {
      dispatch(setUpdateAgreementRequired(false));
      dispatch(setRILoginWithOpenIdForce(false));
      return;
    }

    const userAcceptedAgreementList = userData.currentAgreementList;
    const agreementList: AgreementListProps[] = onInıtData?.AgreementList;

    const isAcceptedBefore = userAcceptedAgreementList?.some((e: any) => e.AgreementType === 7);
    const newVersion = agreementList?.find((e) => e.AgreementType === 7)?.AgreementVersion;
    const acceptedVersion7 = userAcceptedAgreementList?.find((e: any) => e.AgreementType === 7)?.AgreementVersion;

    // RILoginWithOpenIdForce: API'den true geliyorsa set et
    const riLoginForceFromApi = customerInfo?.data?.RILoginWithOpenIdForce === true;
    
    if (riLoginForceFromApi) {
      dispatch(setRILoginWithOpenIdForce(true));
    }

    // RILoginWithOpenIdForce true ise veya agreement güncellenmesi gerekiyorsa
    if (riLoginForceFromApi || !isAcceptedBefore || acceptedVersion7 !== newVersion) {
      dispatch(setUpdateAgreementRequired(true));
    } else {
      dispatch(setUpdateAgreementRequired(false));
    }
  };

  
  // Open security image dialog if not set
  useEffect(() => {
    if (securityImageId === 0) {
      dispatch(setSecurityImageDialogOpen(true));
    }
  }, [securityImageId]);
  
  useEffect(() => {
    checkAgreementStatus();
  }, [userData.currentAgreementList, customerInfo]);
  // Open dialog only when unsuccessful login detected
  useEffect(() => {
    if (!isDialogDismissed && shouldShowUnsuccessLoginDialog) {
      setIsLoginLogDialogOpen(true);
    }
  }, [shouldShowUnsuccessLoginDialog, isDialogDismissed]);

  useEffect(() => {
    dispatch(
      onGetMasterpassTokenRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
        TokenType: MasterPassTokenEnum.CHECK_MASTERPASSS,
        request: {
          data: checkMasterPassAccountNormalize(),
        },
      })
    );
    dispatch(
      onGetCustomerInfoRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
      })
    );
    dispatch(
      onGetLoginLogListRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
      })
    );
    dispatch(
      getCampaignsRequest({
        LanguageId: languageId,
        Token: sessionToken,
        CardId: '18',
      })
    );
    dispatch(getNewsRequest());
    dispatch(
      getCityListRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
      })
    );
  }, []);

  return (
    <Fragment>
      <DashboardLayout>
        <Fragment>
          {updateRequired && <UpdateAgreements />}
          {/*   <SpecialOpportunity /> */}
          {!!web_warning_visible_all && !updateRequired && <WarnAndTips />}
          {((userCampaigns && userCampaigns?.length > 0) || (userNews && userNews?.length > 0)) && !updateRequired && (
            <NewsAndCampaigns />
          )}
        </Fragment>
      </DashboardLayout>
      
{/* Last Login Information Dialog */}
      <Dialog
        open={isLoginLogDialogOpen}
        onClose={() => setIsLoginLogDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 20,
            padding: '24px 8px 16px 8px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          }
        }}
      >
        <DialogTitle style={{ 
          fontWeight: 700, 
          textAlign: 'left',
          fontSize: '22px',
          color: '#2c3e50',
          paddingBottom: 24,
          paddingLeft: 16,
          paddingRight: 16,
        }}>
          Son giriş bilgilerim
        </DialogTitle>
        <DialogContent style={{ paddingLeft: 16, paddingRight: 16 }}>
          <Box>
            {lastTwoLogins.map((login, index) => (
              <Box 
                key={index} 
                style={{ 
                  marginBottom: index < lastTwoLogins.length - 1 ? 16 : 0,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="body2"
                  style={{
                    color: '#666',
                    fontSize: '15px',
                    fontWeight: 400,
                  }}
                >
                  {moment(login.InsertDate).format('DD.MM.YYYY / HH:mm')}
                </Typography>
                <Typography
                  variant="body2"
                  style={{
                    color: login.LoginStatus === 'Başarılı' ? '#4CAF50' : '#f44336',
                    fontSize: '15px',
                    fontWeight: 600,
                  }}
                >
                  {login.LoginStatus === 'Başarılı' ? 'Başarılı giriş' : 'Başarısız giriş'}
                </Typography>
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions style={{ 
          padding: '24px 16px 8px 16px',
          flexDirection: 'column',
          gap: 8,
        }}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              sessionStorage.setItem('loginLogDialogDismissed', 'true');
              setIsDialogDismissed(true);
              setIsLoginLogDialogOpen(false);
            }}
            style={{
              backgroundColor: '#2c3e50',
              color: 'white',
              borderRadius: 12,
              padding: '14px',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 'none',
            }}
          >
            Tamam
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => {
              setIsLoginLogDialogOpen(false);
              history.push(routePath.loginInformation);
            }}
            style={{
              color: '#2c3e50',
              borderRadius: 12,
              padding: '14px',
              fontSize: '16px',
              fontWeight: 500,
              textTransform: 'none',
            }}
          >
            Son giriş bilgilerim
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
});
export default Home;
